module.exports = __webpack_public_path__ + "img/log-out-icon.93812f40.svg";